import React from 'react';
import Journal from './../Single';
import {
    NavLink,
    Link
} from 'react-router-dom'
class RecentJournals extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let related_journals = this.props.related_journals ? this.props.related_journals : [];
        let types = this.props.types;
        let journals_html = related_journals.map((item, key) => {
            if(Object.keys(item).length){
                return <Journal item={item} type={types[item.type]} key={key} noImg={true} />
            }
        })
        return (
            <div className="journal-list grid-3 title-sm">
                {journals_html}
            </div>
        );
    }
}

export default RecentJournals;


// WEBPACK FOOTER //
// ./src/components/Journals/Details/RecentJournals.js